export default __webpack_public_path__ + "static/media/email-icon.6ae6f3b3.svg";